import Calendar5 from '@crehana/icons/Calendar5';
import Calendar5Filled from '@crehana/icons/Calendar5Filled';
import Diploma from '@crehana/icons/Diploma';
import FileText from '@crehana/icons/FileText';
import FileTextOutline from '@crehana/icons/FileTextOutline';
import BookmarkFilled from '@crehana/icons/fill/Bookmark';
import Bookmark from '@crehana/icons/outline/Bookmark';
import Pencil from '@crehana/icons/Pencil';
import PencilOutline from '@crehana/icons/PencilOutline';
import PlaySquare from '@crehana/icons/PlaySquare';
import PlaySquareOutline from '@crehana/icons/PlaySquareOutline';

import type { RouteType } from '../components/DashboardTemplate/types';
import ClassNotes from './ClassNotes';
import Diplomas from './Diplomas';
import Enrollments from './Enrollments';
import Projects from './Projects';
import SavedCourses from './SavedCourses';
import StudyPlan from './StudyPlan';

export const BASE_URL = '/panel';

export const ENROLLMENTS_COURSES_ROUTE = {
  key: 'COURSES',
  path: '',
};

export const ENROLLMENTS_BOOTCAMPS_ROUTE = {
  key: 'BOOTCAMPS',
  path: 'bootcamp/',
};

export const ENROLLMENTS_DEGREES_ROUTE = {
  key: 'DEGREES',
  path: 'microdegree/',
};

export const ENROLLMENTS_ACADEMIES_ROUTE = {
  key: 'ACADEMIES',
  path: 'academias/',
};

export const ENROLLMENTS_TRACKS_ROUTE = {
  key: 'TRACKS',
  path: 'especializaciones/',
};

export const ENROLLMENTS_CAREERS_ROUTE = {
  key: 'CAREERS',
  path: 'carreras/',
};

export const ENROLLMENTS_BUNDLES_ROUTE = {
  key: 'BUNDLES',
  path: 'certificaciones/',
};

export const ENROLLMENTS_ROUTES = [
  ENROLLMENTS_COURSES_ROUTE,
  ENROLLMENTS_DEGREES_ROUTE,
  ENROLLMENTS_ACADEMIES_ROUTE,
  ENROLLMENTS_TRACKS_ROUTE,
  ENROLLMENTS_BOOTCAMPS_ROUTE,
  ENROLLMENTS_CAREERS_ROUTE,
  ENROLLMENTS_BUNDLES_ROUTE,
];

export const ENROLLMENTS_ROUTE = {
  key: 'ENROLLMENTS',
  path: '/mis-cursos/',
  subpaths: ENROLLMENTS_ROUTES.map(route => route.path),
  exact: false,
  component: Enrollments,
  icon: PlaySquareOutline,
  activeIcon: PlaySquare,
  tourSelector: 'enrollments-tab',
};

export const CLASSNOTES_ROUTE = {
  key: 'CLASSNOTES',
  path: '/mis-apuntes/',
  exact: true,
  component: ClassNotes,
  icon: FileTextOutline,
  activeIcon: FileText,
  tourSelector: 'classnotes-tab',
};

export const PROJECTS_ROUTE = {
  key: 'PROJECTS',
  path: '/mis-proyectos/',
  exact: true,
  component: Projects,
  icon: PencilOutline,
  activeIcon: Pencil,
  tourSelector: 'projects-tab',
};

export const DIPLOMAS_ROUTE = {
  key: 'DIPLOMAS',
  path: '/mis-diplomas/',
  exact: true,
  component: Diplomas,
  icon: Diploma,
  activeIcon: Diploma,
  tourSelector: 'diplomas-tab',
};

export const STUDY_PLAN_ROUTE = {
  key: 'STUDY_PLAN',
  path: '/mi-plan-de-estudios/',
  exact: true,
  component: StudyPlan,
  icon: Calendar5,
  activeIcon: Calendar5Filled,
  tourSelector: 'study-plan-tab',
};

export const SAVED_COURSES_KEY = 'SAVED_COURSES';
export const SAVED_COURSES_SELECTOR = 'saved-courses-tab';
export const SAVED_COURSES_ROUTE = {
  key: SAVED_COURSES_KEY,
  path: '/mis-cursos-guardados/',
  exact: false,
  component: SavedCourses,
  icon: Bookmark,
  activeIcon: BookmarkFilled,
  tourSelector: SAVED_COURSES_SELECTOR,
};

const ROUTES: Omit<RouteType, 'label'>[] = [
  ENROLLMENTS_ROUTE,
  SAVED_COURSES_ROUTE,
  CLASSNOTES_ROUTE,
  PROJECTS_ROUTE,
  DIPLOMAS_ROUTE,
  STUDY_PLAN_ROUTE,
];

export default ROUTES;
